import { USE_MOCK } from '@/lib/api/env';
import { createRealtimeClient } from './createRealtimeClient';
import type { LiveRealtimeClient } from './types';

let singleton: LiveRealtimeClient | null = null;

/**
 * ONE socket per tab. Chat, presence, notifications, calls and the channel feed
 * all share it — a socket per feature would multiply the gateway's connection
 * count by five for no benefit, and the protocol is already multiplexed.
 *
 * Under `VITE_USE_MOCK` nothing calls this: the mock adapters never open a
 * socket, so the offline demo stays completely server-free.
 */
export function getRealtimeClient(): LiveRealtimeClient {
  if (singleton === null) singleton = createRealtimeClient();
  return singleton;
}

/** True when the live socket is in play (i.e. adapters should subscribe). */
export const REALTIME_ENABLED: boolean = !USE_MOCK;

export { createRealtimeClient } from './createRealtimeClient';
export { backoffMs } from './backoff';
export { Sequencer, isDurable } from './sequencer';
export type {
  ConnectionState,
  LiveRealtimeClient,
  OutgoingFrame,
  RealtimeClient,
  RealtimeDelivery,
} from './types';
